import Offcanvas from 'bootstrap/js/dist/offcanvas';

function NavMenuMobileSlideOver() {
    const navMainOffcanvasElement = document.getElementById("nav-main-offcanvas")
    //const navMainOffcanvas = (navMainOffcanvasElement !== null) ? Offcanvas.getOrCreateInstance(navMainOffcanvasElement) : null;

    const navMainSubmenuOffcanvasElement1 = document.getElementById("nav-main-submenu-1--offcanvas");
    const navMainSubmenuOffcanvasBody1 = document.getElementById("nav-main-submenu-1--offcanvas-body");
    const navMainSubmenuOffcanvas1 = (navMainSubmenuOffcanvasElement1 !== null) ? Offcanvas.getOrCreateInstance(navMainSubmenuOffcanvasElement1) : null;

    const navMainSubmenuOffcanvasElement2 = document.getElementById("nav-main-submenu-2--offcanvas");
    const navMainSubmenuOffcanvasBody2 = document.getElementById("nav-main-submenu-2--offcanvas-body");
    const navMainSubmenuOffcanvas2 = (navMainSubmenuOffcanvasElement2 !== null) ? Offcanvas.getOrCreateInstance(navMainSubmenuOffcanvasElement2) : null;


    function openMobileSubmenuOffcanvas(event) {
        if (!event.target.classList.contains('dropdown-toggle-mobile')) {
            return;
        }

        //event.preventDefault();
        //$(this).blur();

        const depth = parseInt(event.target.dataset.depth);

        const dropdownMenu = event.target.nextElementSibling;

        const submenuElement = (depth === 1) ? navMainSubmenuOffcanvasElement1 : navMainSubmenuOffcanvasElement2;

        const submenuBody = (depth === 1) ? navMainSubmenuOffcanvasBody1 : navMainSubmenuOffcanvasBody2;

        const submenuOffcanvas = Offcanvas.getOrCreateInstance(
            submenuElement,
            {
                backdrop: false, keyboard: false
            }
        );

        if (submenuOffcanvas !== null) {
            requestAnimationFrame(() => {
                submenuBody.innerHTML = '<ul class="sub-dropdown-menu"><li><a class="sub-menu-back uppercase" role="button" data-bs-dismiss="offcanvas">Back</a></li>' + dropdownMenu.innerHTML + '</ul>';
            });

            // requestAnimationFrame(() => {
            //     submenuBody.innerHTML += dropdownMenu.innerHTML;
            // });

            const dropdownItems = submenuBody.querySelectorAll('.dropdown-item');

            dropdownItems.forEach(element => {
                requestAnimationFrame(() => {
                    element.classList.remove('dropdown-item')
                });
            });

            requestAnimationFrame(() => {
                setTimeout(() => {
                    submenuOffcanvas.show();
                }, 0);
            });
        }
    }


    // Allow mobile trigger buttons to open submenus
    document.addEventListener('click', openMobileSubmenuOffcanvas);

    // if (dropdownMobileToggles.length) {
    //     dropdownMobileToggles.forEach(element => {
    //         element.addEventListener('click', openMobileSubmenu);
    //     })
    // }

    // Close submenu offcanvases when main menu is closed
    if (navMainOffcanvasElement !== null && navMainSubmenuOffcanvas1 !== null) {
        navMainOffcanvasElement.addEventListener('hide.bs.offcanvas', event => {
            if (navMainSubmenuOffcanvas1 !== null) {
                if (navMainSubmenuOffcanvas1._isShown) {
                    navMainSubmenuOffcanvas1.hide();
                }
            }

            if (navMainSubmenuOffcanvas2 !== null) {
                if (navMainSubmenuOffcanvas2._isShown) {
                    navMainSubmenuOffcanvas2.hide();
                }
            }
        });
    }

    // Close main offcanvas when submenu is closed
    // if (navMainSubmenuOffcanvasElement1 !== null) {
    //     navMainSubmenuOffcanvasElement1.addEventListener('hidden.bs.offcanvas', event => {
    //         if (navMainOffcanvas._isShown) {
    //             navMainOffcanvas.hide();
    //         }
    //     });
    // }

    // Close other offcanvas when submenu is closed
    // if (navMainSubmenuOffcanvasElement2 !== null) {
    //     navMainSubmenuOffcanvasElement2.addEventListener('hidden.bs.offcanvas', event => {
    //         if (navMainOffcanvas._isShown) {
    //             navMainOffcanvas.hide();
    //         }
    //     });
    // }


    // function closeAllMenus()
    // {
    //     const openMenus = document.querySelectorAll(".nav-main .is-open");
    //     if (!openMenus.length) {
    //         return;
    //     }

    //     openMenus.forEach(element => {
    //         requestAnimationFrame(() => {
    //             element.classList.remove('is-open');
    //         });
    //     });
    // }


    // Close menu items with Escape key
    // window.addEventListener(
    //     "keydown",
    //     (event) => {
    //         if (event.defaultPrevented) {
    //         return; // Do nothing if the event was already processed
    //         }

    //         switch (event.key) {
    //         case "Escape":
    //             closeAllMenus();
    //             break;

    //         default:
    //             return; // Quit when this doesn't handle the key event.
    //         }

    //         // Cancel the default action to avoid it being handled twice
    //         event.preventDefault();
    //     },
    //     true,
    //     );
}

export default NavMenuMobileSlideOver;